import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import Checkbox from "../../Elements/Checkbox/Checkbox";
import "../CheckoutPanel/CheckoutPanel.css";

const LegalFooter = ({
  isGuest,
  newsletterOptIn,
  onNewsletterOptInChange,
  speedConfirmed,
  onSpeedConfirmChange,
  isUnlimited,
  showNewsletterCheckbox,
  onNewsletterOptInGuestChange,
}) => {
  const { t } = useTranslation();
  const showSpeedCheckbox = isUnlimited;

  return (
    <>
      {isGuest ? (
        <div className="summary-legal-guest">
          <span className="summary-legal__text">
            {t("cart.placeOrderAgreement")}{" "}
            <Link to="/terms" className="summary-legal__link">
              {t("footer.terms")}
            </Link>{" "}
            {t("auth.and")}{" "}
            <Link to="/privacy-policy" className="summary-legal__link">
              {t("footer.privacy")}
            </Link>
            .
          </span>

          {showSpeedCheckbox && (
            <Checkbox
              id="speed-warning-guest"
              label={
                <>
                  {t("cart.speedWarning")}
                  <HashLink
                    to="/terms#art-17-unlimited"
                    className="summary-legal__link"
                    scroll={(el) =>
                      el.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                      })
                    }
                  >
                    {t("cart.unlimitedPlanDetails")}
                  </HashLink>
                  {")"}.
                </>
              }
              checked={speedConfirmed}
              onChange={(e) => onSpeedConfirmChange(e.target.checked)}
            />
          )}
        </div>
      ) : (
        <div className="summary-legal">
          <span className="summary-legal__text">
            {t("cart.placeOrderAgreement")}{" "}
            <Link to="/terms" className="summary-legal__link">
              {t("footer.terms")}
            </Link>{" "}
            {t("auth.and")}{" "}
            <Link to="/privacy-policy" className="summary-legal__link">
              {t("footer.privacy")}
            </Link>
            .
          </span>

          {showSpeedCheckbox && (
            <Checkbox
              id="speed-warning-user"
              label={
                <>
                  {t("cart.speedWarning")}
                  <HashLink
                    to="/terms#art-17-unlimited"
                    className="summary-legal__link"
                    scroll={(el) =>
                      el.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                      })
                    }
                  >
                    {t("cart.unlimitedPlanDetails")}
                  </HashLink>
                  {")"}.
                </>
              }
              checked={speedConfirmed}
              onChange={(e) => onSpeedConfirmChange(e.target.checked)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default LegalFooter;
